export default __webpack_public_path__ + "static/media/valuesIcon.edd078b6.png";